import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppValueTypes } from '@iotv/iotv-v3-types';
import { Stack, Typography } from '@mui/material';
import { AdjacentType } from '../../../types';
import { DownloadButton } from '../../common/ViewObjectDownloadButton';
import { useMemo } from 'react';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ViewObjectDownloadButtonWidget = () => {
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "DownloadButton" }), _jsx(Stack, { direction: "row", children: _jsx(DownloadButton, { viewObject: {
                        matchedPrimary: {
                            name: 'Object',
                            type: '',
                            pk: '',
                            sk: '',
                            id: '',
                        },
                        matchedRelatedByPk: undefined,
                        matchedRelatedBySk: undefined,
                        largeObject: undefined,
                    }, viewDefinition: {
                        ['name']: {
                            key: 'name',
                            type: AppValueTypes.STRING,
                            label: 'Name',
                            editable: false,
                        },
                    }, adjacentFilter: {
                        adjacentType: AdjacentType.SUBJECT,
                        objectType: 'Organization',
                        edgeFilter: undefined,
                        filterConfig: undefined,
                        otherObjectType: undefined,
                        groupSupportedType: undefined,
                    } }) })] })), []);
    return {
        name: 'ViewObjectDownloadButton',
        category: 'common',
        component,
    };
};
